
// SVG Icon: expandAll
export default { id: "terriajs-expandAll" };
export const id = "terriajs-expandAll";
export const name = "expandAll";
